module.exports = __webpack_public_path__ + "static/media/results_single_response.fa41447d.png";